import { hydrateTokenFromServer, TOKEN_KEY } from '../../stores/AppStore'
import { refreshToken } from '../../api/account'
import cookie from 'js-cookie'
let isRefreshing = false
let queue = []
const defaultOptions = {forceRefetch: false}

export default store => (options = defaultOptions) => {
  let requestResolver
  let requestRejector
  let requestPromise = new Promise((resolve, reject) => {
    requestResolver = resolve
    requestRejector = reject
  })

  // If the token is currently refreshing, enqueue the current request until refresh is complete
  if (isRefreshing) {
    queue.push([requestResolver, requestRejector])
    return requestPromise
  }

  // If the token is currently NOT refreshing, check it's validity
  const { accessToken, token } = store.getState()
  const now = new Date()
  const expiryDate = new Date(
    accessToken.accessTokenTTLMS + accessToken.acquiredAtMS,
  )

  // Valid token, resolve it
  if (!options.forceRefetch && now.getTime() < expiryDate.getTime()) {
    requestResolver(token)

    return requestPromise
  }

  // Expired token, refresh it
  isRefreshing = true

  refreshToken(token)
    .then(response => {
      if (response.status !== 200) {
        throw new Error('Error refreshing access token')
      }
      return response.json()
    })
    .then(({ token }) => {
      hydrateTokenFromServer(store)({ token })

      // Resolve pending requests
      queue.forEach(([resolve, reject]) => resolve(token))
      requestResolver(token)
    })
    .catch(error => {
      cookie.remove(TOKEN_KEY)
      window.location.assign('/login') // should we use Gatsby's navigate here intead of window?
      queue.forEach(([resolve, reject]) => reject(error))
    })
    .finally(() => {
      isRefreshing = false
      queue = []
    })

  return requestPromise
}
